document.addEventListener('DOMContentLoaded', () => {
    const titleToIdMap = {
        Najnowsze: 'najnowsze',
        Polecane: 'polecane',
        Wywiady: 'wywiady',
        'Czas wolny': 'czas-wolny',
        'Przeczytaj także': 'przeczytaj-takze-lista',
        'Poprzedni artykuły': 'poprzedni-artykul',
        'Następny artykuł': 'nastepny-artykul',
        'Podobne artykuły': 'podobne-artykuly',
        'Hero Slider': 'hero-slider',
    };

    const sentViews = new Set();
    const sentListViews = new Set();

    // Observer dla pojedynczych artykułów (article_view)
    const articleObserver = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                    const el = entry.target;
                    const title = (el.dataset.articleTitle || '')
                        .trim()
                        .replace(/\s+/g, ' ');
                    const name = el.dataset.sectionName || 'nieznana-sekcja';
                    const id = el.dataset.sectionId || 'nieznana-sekcja';

                    const key = title + '|' + id;

                    if (!sentViews.has(key)) {
                        sentViews.add(key);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'article_view',
                            article_title: title,
                            article_list_name: name,
                            article_list_id: id,
                        });
                    }
                }
            });
        },
        { threshold: 0.5 }
    );

    // Observer dla sekcji artykułów (article_list_view)
    const sectionObserver = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
                    const section = entry.target;
                    const name =
                        section.dataset.sectionName || 'nieznana-sekcja';
                    const id = section.dataset.sectionId || 'nieznana-sekcja';

                    // 🟡 article_list_view (raz na sekcję)
                    if (!sentListViews.has(id)) {
                        sentListViews.add(id);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'article_list_view',
                            article_list_name: name,
                            article_list_id: id,
                        });
                    }
                }
            });
        },
        { threshold: 0.3 }
    );

    function setupTrackingForElement(el, title, sectionName, sectionId) {
        el.dataset.articleTitle = title;
        el.dataset.sectionName = sectionName;
        el.dataset.sectionId = sectionId;

        articleObserver.observe(el);

        el.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'article_click',
                article_title: title,
                article_list_name: sectionName,
                article_list_id: sectionId,
            });
        });
    }

    // Hero Slider
    document.querySelectorAll('.hero__sliderItem').forEach(slide => {
        const titleEl = slide.querySelector('.hero__slideTitle a');
        if (!titleEl) return;

        const title = titleEl.textContent.trim();
        setupTrackingForElement(
            slide,
            title,
            'Hero Slider',
            titleToIdMap['Hero Slider']
        );
    });

    // Sekcje artykułowe (w tym .article-list__subgrid)
    document.querySelectorAll('.article-list').forEach(section => {
        const header = section.querySelector('.article-list__title h2');
        const sectionName = header?.textContent.trim() || 'nieznana-sekcja';
        const sectionId =
            titleToIdMap[sectionName] ||
            sectionName.toLowerCase().replace(/\s+/g, '-');

        section.dataset.sectionName = sectionName;
        section.dataset.sectionId = sectionId;
        sectionObserver.observe(section);

        section.querySelectorAll('.article-list__item').forEach(article => {
            const titleEl =
                article.querySelector(
                    '.card-article__title span.typo-h4, .card-article__title span.typo-h6'
                ) || article.querySelector('.article-list__itemTitle a');
            if (!titleEl) return;

            const title = titleEl.textContent.trim();
            setupTrackingForElement(article, title, sectionName, sectionId);
        });
    });
});
